import { render, staticRenderFns } from "./adjustment.vue?vue&type=template&id=2422b50a&scoped=true&"
import script from "./adjustment.vue?vue&type=script&lang=js&"
export * from "./adjustment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2422b50a",
  null
  
)

export default component.exports